import { render, staticRenderFns } from "./CjhdSubmit.vue?vue&type=template&id=56b71765&scoped=true"
import script from "./CjhdSubmit.vue?vue&type=script&lang=js"
export * from "./CjhdSubmit.vue?vue&type=script&lang=js"
import style0 from "./CjhdSubmit.vue?vue&type=style&index=0&id=56b71765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b71765",
  null
  
)

export default component.exports